<template>
  <div>
    <a href="https://slicejobs-tech.feishu.cn/wiki/IFSEwU6zhi3fetk53uScDxFPnwh"
       target="_blank"
       style="position:absolute;right:200px;bottom:18px;color:red"
    >查看任务&工单&证据归档说明
    </a>
    <a href="http://img-cn-shanghai.aliyuncs.com/taskdesc/190603/50/ad816a4cf26d21609f15540fa701c174.png"
       target="_blank"
       style="position:absolute;right:10px;bottom:18px"
    >查看任务&工单&零工说明
    </a>
  </div>
</template>

<script>
export default {
  name: 'TaskDescButton',
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/task/components/buttons/TaskDescButton.vue